import SignInWithGoogle from "../assets/icons/sign-in-with-google.svg";

const useLogin = () => {
  const requestGoogleAuth = async () => {
    const redirectUri = window.origin + "/auth";
    const authUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&scope=https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=token`;
    window.location.href = authUrl;
  };

  return {
    requestGoogleAuth,
  };
};

const SignInScreen = () => {
  const { requestGoogleAuth } = useLogin();
  return (
    <button
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        padding: "1rem",
        fontSize: "14",
        borderRadius: 5,
        border: 1,
      }}
      onClick={requestGoogleAuth}
    >
      <img src={SignInWithGoogle} alt="Sign In With Google" />
      <span style={{ marginLeft: ".5rem" }}>Sign In With Google</span>
    </button>
  );
};

export const CustomLoginPage = ({ error }: { error?: string | null }) => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <h1>Bits Money Admin Login</h1>
      {error ? <h5>{error}</h5> : null}
      <SignInScreen />
    </div>
  );
};
